import {
  APPEND_PRODUCT_IN_TICKET,
  CLOSE_MODAL_SUCCESS,
  CLOSE_MODAL_CONFIRMATION_TICKET,
  MAKE_SELF_SERVICE_ERROR,
  MAKE_SELF_SERVICE_LOADING,
  MAKE_SELF_SERVICE_SUCCESS,
  OPEN_MODAL_SUCCESS,
  OPEN_MODAL_CONFIRMATION_TICKET,
  CONFIRMATION_TICKET,
  SET_TICKETS,
  TICKETS_ERROR,
  TICKETS_LOADING,
  TICKETS_NOT_FOUND,
  VALIDATE_PRODUCT_BY_MOTIVE_LOADING,
  VALIDATE_PRODUCT_BY_MOTIVE_ERROR,
  VALIDATE_PRODUCT_BY_MOTIVE_SUCCESS,
  CREATE_TICKET_NO_PRODUCT_LOADING,
  CREATE_TICKET_NO_PRODUCT_SUCCESS,
  CREATE_TICKET_NO_PRODUCT_ERROR,
  SET_STATUS,
  SET_MESSAGES,
} from '../types/TicketTypes';

const initialState = {
  tickets: [],
  ticketStatus: 'idle',
  validation: {},
  validationStatus: 'idle',
  selfService: {},
  selfServiceStatus: 'idle',
  openModalSuccessTicketCreate: false,
  openModalConfirmationTicket: false,
  modalInformation: {},
  ticket: {},
  ticketNoProductStatus: 'idle',
  messageResponse: '',
  showForm: false,
};

const ticketReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TICKETS:
      return {
        ...state,
        tickets: action.tickets,
        ticketStatus: 'succeded',
      };
    case TICKETS_LOADING:
      return {
        ...state,
        tickets: [],
        ticketStatus: 'loading',
      };
    case TICKETS_NOT_FOUND:
      return {
        ...state,
        tickets: [],
        ticketStatus: 'notFound',
      };
    case TICKETS_ERROR:
      return {
        ...state,
        tickets: [],
        ticketStatus: 'error',
      };
    case APPEND_PRODUCT_IN_TICKET:
      return {
        ...state,
        tickets: state.tickets.map((ticket) =>
          ticket.sku === action.sku
            ? {
                ...ticket,
                ...action.product,
              }
            : ticket,
        ),
      };
    case VALIDATE_PRODUCT_BY_MOTIVE_LOADING:
      return {
        ...state,
        validationStatus: 'validating',
      };
    case VALIDATE_PRODUCT_BY_MOTIVE_ERROR:
      return {
        ...state,
        validation: action.validation,
        validationStatus: 'error',
      };
    case VALIDATE_PRODUCT_BY_MOTIVE_SUCCESS:
      return {
        ...state,
        validation: action.validation,
        validationStatus: 'succeded',
      };
    case MAKE_SELF_SERVICE_ERROR:
      return {
        ...state,
        selfServiceStatus: 'error',
        modalInformation: {},
      };
    case MAKE_SELF_SERVICE_LOADING:
      return {
        ...state,
        selfServiceStatus: 'loading',
      };
    case MAKE_SELF_SERVICE_SUCCESS:
      return {
        ...state,
        selfServiceStatus: 'succeded',
        selfService: action.selfService,
      };
    case OPEN_MODAL_SUCCESS:
      return {
        ...state,
        openModalSuccessTicketCreate: true,
        modalInformation: action.modalInformation,
      };
    case CLOSE_MODAL_SUCCESS:
      return {
        ...state,
        selfServiceStatus: 'idle',
        ticketNoProductStatus: 'idle',
        openModalSuccessTicketCreate: false,
        modalInformation: {},
      };
    case OPEN_MODAL_CONFIRMATION_TICKET:
      return {
        ...state,
        openModalConfirmationTicket: true,
        modalInformation: action.modalInformation,
      };
    case CLOSE_MODAL_CONFIRMATION_TICKET:
      return {
        ...state,
        openModalConfirmationTicket: false,
        modalInformation: {},
      };
    case CONFIRMATION_TICKET:
      return {
        ...state,
        confirmationTicket: true,
        openModalConfirmationTicket: false,
      };
    case CREATE_TICKET_NO_PRODUCT_ERROR:
      return {
        ...state,
        ticketNoProductStatus: 'error',
      };
    case CREATE_TICKET_NO_PRODUCT_LOADING:
      return {
        ...state,
        ticketNoProductStatus: 'loading',
      };
    case CREATE_TICKET_NO_PRODUCT_SUCCESS:
      return {
        ...state,
        ticketNoProductStatus: 'succeded',
        ticket: action.ticket,
      };
    case SET_MESSAGES:
      return {
        ...state,
        messageResponse: action.msg,
      };
    case SET_STATUS:
      return {
        ...state,
        showForm: action.status,
      };
    default:
      return state;
  }
};

export default ticketReducer;
